// extracted by mini-css-extract-plugin
export default {"container":"ArrowBackLink_container__OFY1o","absolute":"ArrowBackLink_absolute__wPRsT","onboarding":"ArrowBackLink_onboarding__tlKfi"};